import React from 'react';
import classnames from 'classnames';
import { Select } from 'antd';
import { Tag } from '../tag';
import styles from './TagInput.module.scss';
import { sortByAlphabet } from 'shared/utils';

const { Option } = Select;

/**
 * @deprecated
 */
const TagInput = React.memo(
  ({
    name = null,
    error = null,
    touched,
    wrapperClass = null,
    wrapperStyle = 'greyWrapper',
    inputStyle = 'user',
    onChange = () => {},
    value,
    options = [],
    placeholder = '',
    mode = 'tags',
    optionsRender = false,
    ...props
  }) => {
    const onChangeLocal = value => {
      onChange(name, value);
    };

    const renderOptions = () => {
      if (optionsRender) {
        return options
          .sort((a, b) => sortByAlphabet(a?.value, b?.value))
          .map(({ id, value }) => (
            <Option value={id} key={id}>
              {value}
            </Option>
          ));
      }

      return options
        .sort((a, b) => a?.localeCompare(b))
        .map(key => <Option key={key.toString(36)}>{key}</Option>);
    };

    return (
      <div className={styles.root}>
        <div className={classnames(styles[wrapperStyle], wrapperClass)}>
          <Select
            variant="borderless"
            mode={mode}
            defaultValue={value}
            tagRender={Tag}
            style={{ width: '100%' }}
            placeholder={placeholder}
            onChange={onChangeLocal}
            tokenSeparators={[',', ' ', ';']}
            {...props}>
            {renderOptions()}
          </Select>
        </div>
        {Array.isArray(error) ? (
          error.map((err, index) => (
            <span key={index} className={styles.error}>
              {err}
            </span>
          ))
        ) : (
          <span className={styles.error}>{error}</span>
        )}
      </div>
    );
  },
);

export { TagInput };
